function loadFacebookLibrary(callback) {
  var js,
    id = 'facebook-jssdk',
    d = document,
    ref = d.getElementsByTagName('script')[0];

  if (d.getElementById(id)) {
    callback();
  } else {
    (function () {
      js = d.createElement('script');
      js.onload = callback;
      js.id = id;
      js.async = true;
      js.src = '//connect.facebook.net/en_US/all.js';
      ref.parentNode.insertBefore(js, ref);
    }());

    window.fbAsyncInit = function (callback) {
      FB.init({
        appId: '900710209977177',
        channelUrl: BASE_URL + 'assets/js/facebook/channel.html',
        status: true,
        cookie: true,
        xfbml: false,
        version: 'v5.0'
      });
      if (callback) {
        callback();
      }
    };
  }
}

function commonApiAsync(endpoint, key, callback) {
	var width = 552;
	var height = 350;
	var left = (screen.width - width) / 2;
	var top = (screen.height - height) / 2 - 50;

	var child = window.open(BASE_URL + endpoint, key, "width=" + width + ", height=" + height + ", top=" + top + ", left=" + left + ", scrollbars=no");
	if(callback)
	{
		var timer = setInterval(function() {

			if (child.closed) {
				callback((window.hasOwnProperty(key) && window[key]));
				clearInterval(timer);
			}

		}, 500);
	}
}

window.loadFacebookLibrary = loadFacebookLibrary;

window.inAsynInit = function(callback) {

	commonApiAsync('load/api/instagramsetkey', 'instagram', callback);

};

window.flAsynInit = function(callback) {

	commonApiAsync('load/api/auth/flickr', 'flickr', callback);

};

window.dbAsynInit = function(callback) {

	commonApiAsync('load/api/auth/dropbox', 'dropbox', callback);

};

window.gdAsynInit = function(callback) {

	commonApiAsync('load/api/auth/google', 'google', callback);

};

window.abAsynInit = function(callback) {

  commonApiAsync('load/auth/assetbank', 'assetbank', callback);

};
